import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { Popover, ArrowContainer } from 'react-tiny-popover'

import { MenuCategory } from '../app/types/catalog-types'
import { urls } from '../navigation'
import { buttonStyle } from '../controls/buttons'
import { isAnonymousSelector, sessionIdSelector, useURLLang } from '../app/main-slice'
import { useMessages2 } from '../hooks/useLanguage'
import { useAppSelector } from '../app/hooks'
import { AllowedCurrency } from '../app/types/api-types'

import styles from './choose-category.module.css'
import productOverview from '../img/product-overview.jpg';
import { useState } from 'react'

export function ChooseCategory({ categories, currentCurrency, allowedCurrencies, 
                                 onSelectCurrency, onLoadPreviousConfig,
                                 onViewBaskets, onLogOut }: {
    categories: MenuCategory[]
    currentCurrency?: string
    allowedCurrencies?: AllowedCurrency[]
    onLoadPreviousConfig?: () => void
    onViewBaskets?: () => void
    onSelectCurrency?: (v:string) => void
    onLogOut: () => void
}) {

    const lang = useURLLang();
    const { messages} = useMessages2();
    const sessionId = useAppSelector(sessionIdSelector);
    const isAnonymous = useAppSelector(isAnonymousSelector);

    return <div role="presentation" className={styles.chooseCategory}>
        <p className={styles.menuHeader}>{ messages?.intro_category_question }</p>
        <ul className={`${styles.menu} ${styles.catmenu}`}>
            {
                categories.map(category => {
                    return <li key={category.id}>
                        <Link className={buttonStyle} to={urls.category(lang,category.id)}>{category.name}</Link>
                    </li>
                })
            }                
        </ul>
        <ul className={`${styles.menu} ${styles.ctrlmenu}`}>
            <button type="button" disabled={!sessionId} className={buttonStyle} onClick={onLoadPreviousConfig}>{messages?.view_previous_configurations}</button>
            { isAnonymous === false ?
                <>
                    <button type="button" disabled={!sessionId} className={buttonStyle} onClick={onViewBaskets}>{messages?.view_baskets}</button>
                    <button type="button" disabled={!sessionId} className={buttonStyle} onClick={onLogOut}>{messages?.logout_button}</button>
                </>
                :
                null }
            { (allowedCurrencies && currentCurrency && onSelectCurrency) ? 
                <CurrencySelect current={currentCurrency} allowed={allowedCurrencies} onSelect={onSelectCurrency} />
                :
                null }
        </ul>
        <img className={styles.image} src={productOverview} alt="" />
    </div>

}

function CurrencySelect({ current, allowed, onSelect }: {
    current: string
    allowed: AllowedCurrency[]
    onSelect: (v:string) => void
}) {
    const { messages} = useMessages2();
    const [ isOpen, setIsOpen ] = useState(false);

    const _onSelect = (v:string) => {
        onSelect(v);
        setIsOpen(false);
    }

    const content = <ul className={styles.currencymenu}>
        {
            allowed.map(ac => <li><button onClick={() => _onSelect(ac.iso)}>{ac.description}</button></li>)
        }
    </ul>

    return <Popover isOpen={isOpen} padding={0} onClickOutside={() => setIsOpen(false)}
                    positions={['bottom', 'top', 'right', 'left']}
                    content={({ position, childRect, popoverRect }) => 
        <ArrowContainer position={position} childRect={childRect} popoverRect={popoverRect}
                        arrowSize={8} arrowColor="black">
            { content }
        </ArrowContainer>
    }>
        <button type="button" className={`${styles.currencies} ${buttonStyle}`} onClick={() => setIsOpen(!isOpen)}>
            <span>{messages?.currency_selector.replace('{CURRENCY}', current)}</span>
            <span><FontAwesomeIcon icon={faCaretDown}/></span>
        </button>
    </Popover>
}